export const FORMATS = [
  'Core',
  'Infinity',
  'No Limit',
];

export const getFormats = () => FORMATS;